import { Mic, Square } from "lucide-react";
import { useVoiceAnswer } from "@/features/stepper/steptypes/use-voice-answer";

export function VoiceComposer({
  onTranscript,
  onType,
  disabled,
}: {
  onTranscript: (text: string) => void;
  onType: () => void;
  disabled: boolean;
}) {
  const voice = useVoiceAnswer(onTranscript);
  const recording = voice.status === "recording";
  return (
    <div className="sm-chat-voice">
      <button
        type="button"
        className="sm-chat-record"
        disabled={disabled || (voice.busy && !recording)}
        aria-label={recording ? "Stop recording" : "Tap to speak"}
        onClick={() => (recording ? voice.stop() : void voice.start())}
      >
        {recording ? <Square size={20} /> : <Mic size={22} />}
        <span>
          {recording
            ? `Stop recording · ${voice.seconds}s`
            : voice.status === "transcribing"
              ? "Checking your words…"
              : voice.status === "requesting"
                ? "Connecting microphone…"
                : "Tap to speak"}
        </span>
        {recording && (
          <span className="sm-chat-wave" aria-hidden="true">
            {voice.audioLevels.slice(-20).map((level, index) => (
              <i key={index} style={{ height: `${4 + level * 24}px` }} />
            ))}
          </span>
        )}
      </button>
      <button type="button" className="sm-chat-type" onClick={onType}>
        Can’t talk
      </button>
      {voice.error && <p role="alert">{voice.error}</p>}
    </div>
  );
}
